module.exports = __webpack_public_path__ + "img/home-part-two-pic1.53a28d60.png";